import { render, staticRenderFns } from "./UserCRUD.vue?vue&type=template&id=68679d00"
import script from "./UserCRUD.vue?vue&type=script&lang=js"
export * from "./UserCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports